import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import Marker from '../map/marker';
import Paginate from '../paginate';
import classNames from 'classnames';
import { GOOGLE_MAPS_API_KEY, REACT_APP_API_BASE } from '../../config';
import List from './list';
import Table from './table';
import SpinnerDots from '../spinner/dots';
import { ButtonComponent } from '../../components/export-btn';
import Takeover from '../takeover';
import './styles.scss';
const images = require.context('../../images/logotypes', true);

const SearchResult = props => {

    const [activeMarker, setCurrentActiveMarker] = useState(null);

    const [selectedExportFormat, setSelectedExportFormat] = useState('');

    const [exportState, setExportState] = useState({
        isExporting: false
    });

    const [isOpen, toggleExport] = useState(false);

    const getMapBounds = (map, maps, places) => {
        const bounds = new maps.LatLngBounds();
      
        places.forEach((place) => {
          bounds.extend(new maps.LatLng(
            place.Latitude*1,
            place.Longitude*1,
          ));
        });
        return bounds;
      };

    const bindResizeListener = (map, maps, bounds) => {
        maps.event.addDomListenerOnce(map, 'idle', () => {
          maps.event.addDomListener(window, 'resize', () => {
            map.fitBounds(bounds);
          });
        });
    };

    const apiIsLoaded = (map, maps, places) => {
        // Get bounds by our places
        const bounds = getMapBounds(map, maps, places);
        // Fit map to bounds
        map.fitBounds(bounds);
        // Bind the resize listener
        bindResizeListener(map, maps, bounds);
    };

    const getMimeType = (format) => {
        switch (format) {
            case 'excel':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'xml':
                return 'application/xml';
            case 'csv':
                return 'text/csv';
            default: 
                return '';
        }
    }

    const getFileFormat = (format) => {
        switch (format) {
            case 'excel':
                return 'xlsx';
            case 'xml':
                return 'xml';
            case 'csv':
                return 'csv';
            default:
                return '';
        }
    }

    const exportResult = async () => {
        if (selectedExportFormat === '') return;
        
        setExportState({
            isExporting: true
        });

        const search = props.location.search === '' ? '?' : `${props.location.search}&`;

        const res = await props.fetch(`${REACT_APP_API_BASE}/units/search/export${search}format=${selectedExportFormat}`);
        
        if (res.ok) {
            const exportReport = await res.blob();
            var blob = new Blob([exportReport], { type: getMimeType(selectedExportFormat) });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Resultat.${getFileFormat(selectedExportFormat)}`;
            link.click();

            setExportState({
                isExporting: false,
                isExportingFinished: true
            });

            setTimeout(() => {
                setExportState({
                    isExportingFinished: false
                });
                
                setSelectedExportFormat('');


            }, 4000);
        }
    }

    const getExportStateText = () => {
        if (exportState.isExporting) {
            return 'Exporterar enheter';
        }

        if (exportState.isExportingFinished) {
            return 'Klar!';
        }

        return 'Exportera enheter';
    };

    return (
         <section className={classNames({
            'search-result': true,
            'search-result--is-tableview': props.isTableView,
            'search-result--is-mapview': props.isMapView,
            'search-result--is-loading': props.search.isLoading
         })}>
             <div className="search-result__result">
                {props.search.totalCount &&
                    <header className="search-result__header">
                        <h1>{props.search.totalCount} enheter</h1>
                    </header>
                }
                {!props.isTableView && <List result={props.search.data} isLoading={props.search.isLoading} location={props.location} handleMouseOverOut={setCurrentActiveMarker} />}
                {props.isTableView &&  <Table result={props.search.data} isLoading={props.search.isLoading} location={props.location} />}
                <Paginate {...props} />
             </div>
             <aside className={classNames({
                'search-result__map': true,
                'search-result__map--has-footer': props.roles && props.roles.allowedToExportUnits
             })}>
                {props.search.data &&
                    <div style={{width: "100%", height: '100%' }}>
                        <GoogleMapReact 
                            key={props.search.data[0] && props.search.data[0].id ? props.search.data[0].id : 'loadinig'}
                            bootstrapURLKeys={{
                                key: GOOGLE_MAPS_API_KEY,                                            
                                language: 'sv' 
                            }}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, props.search.data)}
                            center={{
                                lat: props.search.data[0] && props.search.data[0].Latitude ? props.search.data[0].Latitude*1 : 61.7512777,
                                lng: props.search.data[0] && props.search.data[0].Longitude ? props.search.data[0].Longitude*1 : 12.9048204
                            }}
                            zoom={props.search.data && props.search.data.filter(e => e.Latitude !== null && e.Longitude !== null).length > 0 ? 11 : 6}
                        >
                            {props.search.data && props.search.data.map((marker, i)  => {
                                let src = null;
                                try {
                                    src = images(`./${marker.ChainCode}.png`);
                                } catch {
                                    src = null;
                                }
                                
                                return (
                                    <Marker
                                        currentActiveMarker={activeMarker}
                                        marker={{...marker, logo: src}}
                                        key={`map${i}`}
                                        lat={marker.Latitude*1}
                                        lng={marker.Longitude*1}
                                        text="My Marker"
                                    />
                                );
                            })}
                            
                        </GoogleMapReact>
                    </div>
                }
                <button className="search-result__close-map" 
                        type="button"
                        onClick={() => props.setMapView(!props.isMapView)}><span>Stäng</span></button>
             </aside>
             <SpinnerDots/>
             {props.roles && props.roles.allowedToExportUnits &&
                <footer className={classNames({
                    'export-footer': true
                })}>
                    <button type="button" className="export-footer__button" onClick={() => toggleExport(!isOpen)} disabled={props.search.isLoading || props.search.totalCount === 0}>Exportera</button>
                </footer>
             }
             <Takeover isOpen={isOpen} toggleTakeover={() => {
                 setSelectedExportFormat('');
                 toggleExport(false)}} heading="Exportera">
                <div>
                    <p>
                        Följande data ({props.search.totalCount} st enheter) kommer att exporteras, kostnaden för detta blir för er med: 
                    </p>
                    <ul>
                        <li>Abo Plus (abonnemang med uppdatering) - fria uttag</li>
                        <li>Abo Bas (abonnemang utan uppdatering) - 3 kronor per enhet</li>
                    </ul>
                    <p>
                        Är ni osäkra på vilket alternativ som gäller för Er kontrollera ert
                        abonnemang alt. kontakta oss på Delfi tel. 08-522 243 00.
                    </p>

                    <div className={classNames({
                        'export-raw': true,
                        'export-raw--exporting': exportState.isExporting,
                        'export-raw--is-finished': exportState.isExportingFinished
                    })}>
                        <div className="export-raw__content">
                            <label className="export-raw__select-lbl">
                                <select className="export-raw__select" onChange={(e) => setSelectedExportFormat(e.currentTarget.value)} value={selectedExportFormat}>
                                    <option value="">Välj filformat</option>
                                    <option value="excel">Excel</option>
                                    <option value="csv">CSV</option>
                                    <option value="xml">XML</option>
                                </select>
                            </label>
                            <ButtonComponent onClick={() => exportResult()} text={getExportStateText()} disabled={selectedExportFormat === ''} />
                            <button className="export-raw__close" type="button" onClick={() => {
                                    setSelectedExportFormat('');
                                    toggleExport(false);
                                }}>Avbryt</button>
                        </div>
                    </div>
                </div>
             </Takeover>
         </section>
    );
};

export default SearchResult;